import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ObservableService {
  private _data$ = new Subject<any>();
  data$ = this._data$.asObservable();

  send(data: any) {
    this._data$.next(data);
  }

  editFare$ = new Subject<void>();
}
